<div
    class="st-story-collaboration-text-editor__editor"
    [froalaEditor]="froalaOptions()"
    [froalaModel]="content()"></div>
